import _slicedToArray from "/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from 'react';
var defaultMode = 'light';
export var ProvideThemeContext = React.createContext({
  mode: defaultMode,
  toggle: function toggle() {}
});
export var useTheme = function useTheme() {
  return React.useContext(ProvideThemeContext);
};
export var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children;

  var _React$useState = React.useState({
    mode: defaultMode
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      themeState = _React$useState2[0],
      setThemeState = _React$useState2[1];

  var toggle = function toggle() {
    setThemeState({
      mode: themeState.mode === 'light' ? 'dark' : 'light'
    });
  };

  return React.createElement(ProvideThemeContext.Provider, {
    value: {
      mode: themeState.mode,
      toggle: toggle
    }
  }, children);
};